<template>
  <transition name="fade">
    <div class="overlay">
      <div class='error-container'>
        <div class="tableHeader">
          <p>We have found error(s) in the document you have uploaded. Please look at the following message(s) and upload again.</p>
          <span class="close" @click='close'>&times;</span>
        </div>
        <div class="scrollable">
          <div v-for='offerMistake in mistakes'>
            <h3>UPC: {{ offerMistake.UPC }}</h3>
            <div class="inline-block">
              <ul class="menu-list" v-if='offerMistake.mistakes.error'>
                <li
                  v-for='error in offerMistake.mistakes.error'
                  :class='{"error-text": error}'>
                {{  error  }}
                </li>
              </ul>
              <ul class="menu-list" v-if='offerMistake.mistakes.warn'>
                <li
                  v-for='warn in offerMistake.mistakes.warn'
                  :class='{"warnings-text": warn}'>
                  {{  warn  }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as NameSpace from 'src/store/NameSpace'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      hasError: false,
      hasWarnings: false
    }
  },
  watch: {
    // clearErrors () {
    //   this.actionResetMistakesInUpload({mistake: [], error: true})
    // }
  },
  methods: {
    close () {
      this.actionResetMistakesInUpload()
    },
    ...mapActions({
      actionResetMistakesInUpload: NameSpace.ACTION_RESET_UPLOAD_FILE
    })
  },
  props: ['clearErrors', 'mistakes']
}
</script>

<style scoped>

  .inline-block {
    padding: 1rem;
  }

  h3 {
      font-size: 1.3rem;
      letter-spacing: .1rem;
      margin: 0;
      margin-left: 3.5rem;
      padding: 1rem 0 0 0;
      display: block;
    }

  .menu-list {
      font-size: 1.3rem;
      letter-spacing: .1rem;
      margin: 0;
  }

  .menu-list .error-text {
    color: red;
  }

  .menu-list .warnings-text {
    color: orange;
  }

  .error-container {
    background-color: #eee;
    width: 100rem;
    height: 51rem;
    position: absolute;
    top: 15%;
    left: 15%;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    text-align: left;
  }

  .close {
    position: absolute;
    top: 0;
    right: 1.1rem;
    font-size: 2.8rem;
    cursor: pointer;
    color: black;
  }

  .scrollable {
      height: 87%;
      margin-right: 1.1rem;
      overflow-y: scroll;
  }

  .tableHeader {
    font-size: 1.2rem;
    color: white;
    height: 10%;
    background-color: red;
    text-align: center;
    padding: .1rem 0 .1rem 0;
  }

  p {
    font-size: 1.4rem;
  }

  .overlay {
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0, 0.9);
    overflow: hidden;
  }

  .overlay span:hover, .overlay span:focus {
    color: white
  }

  @media only screen and (max-width: 1000px) {
    .error-container {
      top: 25%;
    }
  }

  @media only screen and (max-width: 900px) {
    .error-container {
      top: 25%;
      left: 2%;
      right: 2%
    }
  }

  .slide-enter {
    transform: translateX(-15%);
    opacity: 0;
  }

  .slide-enter-active {
    animation: slide-in 1s ease-out forwards;
    transition: opacity 0.5s;
  }

  .slide-leave {
    opacity: 1
  }

  .slide-leave-active {
    animation: slide-out 1s ease-out forwards;
    transition: opacity 1s;
    opacity: 0;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 0.5s;
  }

  .fade-leave {
    opacity: 1
  }

  .fade-leave-active {
    transition: opacity 0.5s;
    opacity: 0;
  }

  @keyframes slide-in {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0px);
    }
  }
  @keyframes slide-out {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(100%);
    }
  }

</style>



// WEBPACK FOOTER //
// Error.vue?65c20d20